module.exports = __webpack_public_path__ + "static/media/Cup.33e7806c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project/icones_apropos/Cup.svg
// module id = 668
// module chunks = 0